import { Dimensions, View } from "react-native";
import { Layer } from "@/constants/glass";

/**
 * Ambient intelligence — the slow colour wash behind the app.
 *
 * Motion belongs to user intent and wayfinding. A permanently moving
 * background competes with the data and can read as a loading state, so the
 * ambient layer stays still while cards and controls respond to the user.
 */
export function AmbientBlobs({ colors }: { colors?: [string, string, string] }) {
  const [color1, color2, color3] = colors ?? [
    "rgba(211,68,54,0.08)",   // Alert Red
    "rgba(201,154,69,0.08)",  // Yield Gold
    "rgba(92,108,130,0.06)",  // Steel Blue
  ];
  const DW = Dimensions.get("window").width;

  const makeBlob = (size: number, color: string, top: number, left: number) => (
    <View
      pointerEvents="none"
      style={[
        {
          position: "absolute",
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: color,
          top,
          left,
        },
        { opacity: 0.09 },
      ]}
    />
  );

  return (
    <View
      pointerEvents="none"
      style={{ position: "absolute", width: "100%", height: "100%", zIndex: Layer.ambient }}
    >
      {makeBlob(DW * 0.6, color1, -DW * 0.1, -DW * 0.1)}
      {makeBlob(DW * 0.5, color2, DW * 0.3, DW * 0.6)}
      {makeBlob(DW * 0.45, color3, DW * 0.6, -DW * 0.05)}
    </View>
  );
}
